import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ja from './locales/ja';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'ja',
  messages: {
    ja,
  },
});

export function generatePathMap(obj: Object, basePath: string = '') {
  return Object.keys(obj).reduce((result, key) => {
    const path = basePath === '' ? key : `${basePath}.${key}`;
    if (typeof obj[key] === 'object') {
      result[key] = generatePathMap(obj[key], path);
    } else {
      result[key] = path;
    }
    return result;
  }, {});
}

export const i18nHints: any = generatePathMap(ja);

Vue.mixin({
  computed: {
    $i18nHints: () => i18nHints,
  },
});
